import { Card, CardContent, CardHeader, Grid } from '@mui/material'
import { blueGrey } from '@mui/material/colors'
import React, { useRef, useState } from 'react'
import {
  ArrayField,
  Edit,
  WithRecord,
  useNotify,
  useRecordContext,
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import AdminNotesPanel from '../../Components/QuoteRequest/Show/AdminNotesPanel'
import CapPanel from '../../Components/QuoteRequest/Show/CapPanel'
import CustomerNotesPanel from '../../Components/QuoteRequest/Show/CustomerNotesPanel'
import VehicleNotesPanel from '../../Components/QuoteRequest/Show/VehicleNotesPanel'
import MitelDataPanel from '../../Components/QuoteRequest/Show/MitelDataPanel'
import {
  CollectionPanel,
  CustomerInfoPanel,
  HistoryTabbedPanel,
  LeadIDPanel,
  VehicleDetailsPanel,
  ViewAgentsPanel,
} from '../../Components/QuoteRequest/Show/Panels'
import PricingNotesPanel from '../../Components/QuoteRequest/Show/PricingNotesPanel'
import VehicleAdjustments from '../../Components/VehicleAdjustments'
import {
  getAdjustmentsSettings,
  getVehicleAdjustments,
  saveVehicleNote,
} from '../../Utils/RestUtils'
import { SalvageBooking } from '../../Components/QuoteRequest'

const ShowQuoteRequest = (props) => {
  const [vehicleAdjustments, setVehicleAdjustments] = useState([])
  const [adjustmentsSettings, setAdjustmentsSettings] = useState([])
  const [nextGridRow, setNextGridRow] = useState(7)
  const [historyPanelSelectedTab, setHistoryPanelSelectedTab] = useState(0)
  const [notes, setNotes] = useState({
    salvageNotes: null,
    quoteNotes: null,
  })
  const [postcodeChanged, setPostcodeChanged] = useState(false)
  const notify = useNotify()
  const notesRef = useRef()

  window.localStorage.setItem('recalculate', 'false')

  const saveNewVehicleNote = async (newVehicleNote, originId) => {
    notesRef.current = notes
    const response = await saveVehicleNote({
      leadId: originId,
      payload: newVehicleNote,
    })

    if (response.result === 'success') {
      setNotes({
        salvageNotes: notes.salvageNotes,
        quoteNotes: newVehicleNote,
      })
    } else {
      notify(response.error_msg, { type: 'error' })
    }
  }

  const { state } = useLocation()
  let fetching = false
  let fetchingAdjustments = false
  let defaultView = 'list'

  if (state != null && state.contactLogScreen != null) {
    defaultView = state.contactLogScreen
  }

  const [contactLogScreen, setContactLogScreen] = useState(defaultView)

  const handleVehicleChange = async (vehicleIri) => {
    try {
      if (!fetchingAdjustments) {
        fetchingAdjustments = true
        const vehicle = await getVehicleAdjustments(vehicleIri)
        const adjSettings = await getAdjustmentsSettings()

        if (vehicleAdjustments.length === 0 && !fetching) {
          fetching = true
          setVehicleAdjustments(vehicle.vehicleAdjustments)
          setAdjustmentsSettings(adjSettings)
        } else if (
          JSON.stringify(vehicleAdjustments) !==
            JSON.stringify(vehicle.vehicleAdjustments) &&
          !fetching
        ) {
          fetching = true
          setVehicleAdjustments(vehicle.vehicleAdjustments)
        }
      }
    } catch (error) {
      notify(error, { type: 'error' })
    }
  }

  const Adjustments = () => {
    const record = useRecordContext()
    if (record) {
      handleVehicleChange(record.id)
    }

    return (
      vehicleAdjustments.length !== 0 && (
        <ArrayField
          source="vehicleAdjustments"
          label={false}
          formClassName="vehicle-adjustments"
        >
          <VehicleAdjustments
            props={props}
            adjustments={vehicleAdjustments}
            adjustmentsSettings={adjustmentsSettings}
          />
        </ArrayField>
      )
    )
  }

  const SalvageSection = (props) => {
    const record = useRecordContext()
    setNextGridRow(10)
    if (record) {
      const isSalvage = record.leadContact.vehicle.tooGoodToScrap
    }
  }

  let isAdmin = false
  const roles = localStorage.getItem('permissions').split(',')

  if (
    roles.includes('ROLE_ADMIN') ||
    roles.includes('ROLE_SALVAGE') ||
    roles.includes('ROLE_SHORE')
  ) {
    isAdmin = true
  }

  return (
    <Edit
      {...props}
      title="View Lead"
      actions={false}
      redirect={false}
      component="div"
      sx={{ '& .RaEdit-noActions': { marginTop: '0 !important' } }}
    >
      <Grid
        style={{
          display: 'grid',
          gap: '0.5rem',
          gridAutoFlow: 'row dense',
          gridTemplateColumns: 'repeat(6, 1fr)',
        }}
      >
        <Grid
          style={{ gridColumn: '1 / span 2', gridRowStart: 2, gridRowEnd: 2 }}
        >
          <Card style={{ height: '100%' }}>
            <CardContent sx={{ paddingBottom: '0' }}>
              <LeadIDPanel {...props} />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          style={{ gridColumn: '3 / span 2', gridRowStart: 2, gridRowEnd: 2 }}
        >
          <Card style={{ height: '100%' }}>
            <CardContent>
              <CustomerInfoPanel
                {...props}
                setContactLogScreen={setContactLogScreen}
                setHistoryPanelSelectedTab={setHistoryPanelSelectedTab}
                setPostCodeChanged={setPostcodeChanged}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          style={{ gridColumn: '5 / span 2', gridRowStart: 2, gridRowEnd: 4 }}
        >
          <Card style={{ height: '100%' }}>
            <CardContent>
              <VehicleDetailsPanel />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          style={{ gridColumn: '1 / span 4', gridRowStart: 3, gridRowEnd: 4 }}
        >
          <Card
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <CardContent sx={{ width: '100%' }}>
              <CollectionPanel />
            </CardContent>
          </Card>
        </Grid>

        <WithRecord
          render={(record) => {
            const isSalvage = record.leadContact.vehicle.tooGoodToScrap
            const roles = localStorage.getItem('permissions').split(',')

            if (
              isSalvage &&
              record.leadContact.vehicle.vehicleCollection &&
              (roles.includes('ROLE_ADMIN') ||
                roles.includes('ROLE_SALVAGE') ||
                roles.includes('ROLE_SHORE'))
            ) {
              return (
                <Grid
                  style={{
                    gridColumn: '1 / span 6',
                    gridRow: 4,
                  }}
                >
                  <Card>
                    <CardContent>
                      <SalvageBooking userRoles={roles} />
                    </CardContent>
                  </Card>
                </Grid>
              )
            }
          }}
        />

        <Grid
          style={{
            gridColumn: '1 / span 3',
            gridRow: '5 / span 2',
            gridAutoRows: '1fr',
          }}
        >
          <Card sx={{ height: '100%', position: 'relative' }}>
            <CardContent sx={{ padding: '0 !important' }}>
              <HistoryTabbedPanel
                {...props}
                setContactLogScreen={setContactLogScreen}
                contactLogScreen={contactLogScreen}
                setHistoryPanelSelectedTab={setHistoryPanelSelectedTab}
                historyPanelSelectedTab={historyPanelSelectedTab}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid
          style={{ gridColumn: '4 / span 3', gridRowStart: 5, gridRowEnd: 5 }}
        >
          <Card>
            <CardHeader
              title="Pricing Notes"
              sx={{
                padding: '10px',
              }}
              titleTypographyProps={{
                sx: {
                  marginBottom: '-15px',
                  textTransform: 'uppercase',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: blueGrey,
                },
              }}
            />
            <CardContent>
              <PricingNotesPanel />
            </CardContent>
          </Card>
        </Grid>

        <Grid
          style={{
            gridColumn: '4 / span 3',
            gridRowStart: 6,
            gridRowEnd: 6,
          }}
        >
          <Card>
            <CardHeader
              title="Admin Notes"
              sx={{
                padding: '10px',
                marginBottom: '1rem',
              }}
              titleTypographyProps={{
                sx: {
                  marginBottom: '-15px',
                  textTransform: 'uppercase',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: blueGrey,
                },
              }}
            />
            <CardContent
              sx={{
                paddingTop: '0',
                '&:last-child': {
                  paddingBottom: '18px',
                },
              }}
            >
              <AdminNotesPanel />
            </CardContent>
          </Card>
        </Grid>
        <SalvageSection />
        <WithRecord
          render={(record) => {
            const isSalvage = record.leadContact.vehicle.tooGoodToScrap
            if (isSalvage) {
              return (
                <React.Fragment>
                  <Grid
                    id="capPanel"
                    style={{
                      gridColumn: '1 / span 6',
                      gridRowStart: 7,
                      gridRowEnd: 7,
                    }}
                  >
                    <Card>
                      <CardContent>
                        <CapPanel />
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid
                    id="customerNotesPanel"
                    style={{
                      gridColumn: '1 / span 3',
                      gridRowStart: 8,
                      gridRowEnd: 8,
                    }}
                  >
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <CardHeader
                          title="Customer submitted notes & photos"
                          sx={{
                            padding: '10px',
                            marginBottom: '1rem',
                          }}
                          titleTypographyProps={{
                            sx: {
                              marginBottom: '-15px',
                              textTransform: 'uppercase',
                              fontSize: '14px',
                              fontWeight: 'bold',
                              color: blueGrey,
                            },
                          }}
                        />
                        <CustomerNotesPanel />
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid
                    id="vehicleNotesPanel"
                    style={{
                      gridColumn: '4 / span 3',
                      gridRowStart: 8,
                      gridRowEnd: 8,
                    }}
                  >
                    <Card>
                      <CardContent>
                        <CardHeader
                          title="Vehicle Notes"
                          sx={{
                            padding: '10px',
                            marginBottom: '1rem',
                          }}
                          titleTypographyProps={{
                            sx: {
                              marginBottom: '-15px',
                              textTransform: 'uppercase',
                              fontSize: '14px',
                              fontWeight: 'bold',
                              color: blueGrey,
                            },
                          }}
                        />
                        <VehicleNotesPanel
                          notes={notes}
                          saveNewVehicleNote={saveNewVehicleNote}
                          editable={true}
                          setNotes={setNotes}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid
                    style={{
                      gridColumn: '1 / span 6',
                      gridRowStart: 9,
                      gridRowEnd: 9,
                    }}
                  >
                    <Card className="vehicle-adjustments">
                      <CardContent>
                        <Adjustments />
                      </CardContent>
                    </Card>
                  </Grid>
                </React.Fragment>
              )
            }
          }}
        />

        <Grid
          id="collectionAgentsPanel"
          style={{
            gridColumn: '1 / span 6',
            gridRowStart: nextGridRow,
            gridRowEnd: nextGridRow,
          }}
        >
          <Card>
            <CardContent sx={{ padding: '0 !important' }}>
              <ViewAgentsPanel
                postcodeChanged={postcodeChanged}
                setPostCodeChanged={setPostcodeChanged}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid
        style={{
          gridColumn: '1 / span 6',
          gridRowStart: nextGridRow + 2,
          gridRowEnd: nextGridRow + 2,
        }}
      >
        <MitelDataPanel />
      </Grid>
    </Edit>
  )
}
export default ShowQuoteRequest
